export default {
  "ORDER_WAIT_SHIP": "Ausstehende Lieferung",
  "Men fashion": "Herrenbekleidung",
  "MyAccount_MyProfile_label_First": "Vorname",
  "MyAccount_MyShippingDetails_Phone": "Telefonnummer",
  "Page_not_found_message1": "Entschuldigung, die Seite konnte nicht gefunden werden",
  "Help": "Hilfe",
  "Sign in": "Anmelden",
  "Register": "Registrieren",
  "Category_sorting_Item": "Sortieroption auswählen",
  "cart_clear": "Warenkorb leeren",
  "Payment & Delivery": "Zahlung und Lieferung",
  "Send my feedback": "Feedback senden",
  "MyAccount_MyProfile_Save": "Änderungen speichern",
  "Continue_billing": "Zur Kasse gehen",
  "Categories": "Kategorien",
  "Read and understand": "Ich habe die Informationen gelesen und verstanden",
  "Feel free to edit": "Bearbeiten Sie Ihre Informationen jederzeit, um Ihr Konto stets aktuell zu halten",
  "Select payment method": "Zahlungsoption auswählen",
  "Login_input_email": "Ihre E-Mail-Adresse",
  "Login_input_first": "Vorname",
  "Account": "Konto",
  "Create_Time_Asc": "Zeitpunkt der Erstellung aufsteigend",
  "concactus_label": "Fragen oder Anliegen",
  "Order_Grade": "Bestellungsbewertung",
  "wishlist_empty_desc": "Es scheint, als hätten Sie noch keine Artikel hinzugefügt. Fangen Sie jetzt an zu shoppen!",
  "cartpreviewShipping_messageinfo": "Versandbestätigung und Lieferdatum",
  "unsubscribe": "Sie können sich jederzeit abmelden",
  "prompt": "Hinweis",
  "MyAccount_MyProfile_yinsi_message": "Bei Brand name ist uns der Datenschutz sehr wichtig und wir setzen uns für den Schutz Ihrer persönlichen Daten ein. Um mehr darüber zu erfahren, wie wir mit Ihren Daten umgehen und was wir damit tun, lesen Sie bitte unsere",
  "About us": "Über uns",
  "or": "oder",
  "MyAccount_Order_History_All": "Alle Bestellungen",
  "What_We_Improve": "Wie können wir uns verbessern?",
  "MyAccount_ShippingDetails_title": "Versanddetails",
  "MyAccount_Order_History_Tabs2": "Zahlung ausstehend",
  "Go_back_shopping": "Weiter einkaufen",
  "Product": "Produkt",
  "Order summary": "Bestellübersicht",
  "payment_order_total": "Bestellsumme",
  "Departments": "Rechtliche Hinweise",
  "Download": "Herunterladen",
  "Your_Purchase_Order": "Ihre Bestellung",
  "Your_Account": "Ihr Konto",
  "order_after_sales_list_null": "Sie haben derzeit keine After Sales-Bestellungen",
  "All_After_sales_orders": "Alle After Sales-Bestellungen",
  "Filters": "Filter",
  "search_results_not": "Wir konnten keine Ergebnisse für Ihre Suche finden",
  "ORDER_WAIT_RECEIPT": "Ausstehende Empfangsbestätigung",
  "ORDER_CLOSED": "Abgeschlossen",
  "Order_View_details": "Details anzeigen",
  "Subscribe_to_message": "Seien Sie der Erste, der von bevorstehenden Verkäufen und Aktionen hört. Erhalten Sie Geschenke und spezielle Angebote!",
  "TaxFee": "Steuern und Gebühren",
  "Apply": "Übernehmen",
  "Total_price": "Gesamtpreis",
  "Description": "Beschreibung",
  "Payment method": "Zahlungsmethode",
  "Back": "Zurück",
  "Empty": "Es scheint, als hätten Sie noch keine Artikel hinzugefügt. Fangen Sie jetzt an zu shoppen, um Ihren Warenkorb zu füllen.",
  "After_sales": "After Sales",
  "Instruction3": "Ja, das wissen wir",
  "MyAccount_MyShippingDetails_Last": "Nachname",
  "MyAccount_MyShippingDetails_City": "Stadt",
  "payment_order_discount": "Bestellrabatt",
  "MyAccount_Order": "Bestelldetails",
  "ID_Name_Error": "Bitte geben Sie den Namen auf Ihrem Ausweis ein",
  "Kidswear": "Kinderbekleidung",
  "Share your look": "Teile deinen Look",
  "Pay_Order": "Bestellung bezahlen",
  "Reset_Password": "Passwort zurücksetzen",
  "MyAccount_MyProfile_label2_pass1": "Aktuelles Passwort",
  "Create_Time_Desc": "Zeitpunkt der Erstellung absteigend",
  "Items": "Artikel",
  "Login_Register": "Jetzt registrieren",
  "Back to homepage": "Zurück zur Homepage",
  "switch_CNY": "Auf Renminbi umstellen",
  "Successful placed order": "Ihre Bestellung wurde erfolgreich aufgegeben. Sie können den Status Ihrer Bestellung mit unserer Lieferstatusfunktion überprüfen. Eine Bestellbestätigungs-E-Mail mit Details und einem Tracking-Link wird Ihnen zugesandt.",
  "MyAccount_MyProfile_yinsi_link": "Datenschutzrichtlinie",
  "Order_Date": "Bestelldatum",
  "Allow order notifications": "Bestellbenachrichtigungen zulassen",
  "MyAccount_MyProfile_Tab1": "Persönliche Daten",
  "MyAccount_ShippingDetails_changeTitle": "Adresse ändern",
  "ID_Number": "Ausweisnummer",
  "Order_after_sales_message": "Details und After Sales-Bestellungen",
  "MyAccount_MyProfile_title2": "Wenn Sie Ihr Passwort für den Zugriff auf Ihr Konto ändern möchten, geben Sie bitte die folgenden Informationen ein:",
  "Customer service": "Kundenservice",
  "MyAccount_MyProfile_Update": "Passwort aktualisieren",
  "choose_language": "Sprache auswählen",
  "ORDER_REFUNDING": "Rückerstattung ausstehend",
  "MyAccount_MyProfile_title1": "Bearbeiten Sie unten jederzeit beliebige Details, um Ihr Konto stets aktuell zu halten",
  "ORDER_WAIT_RATE": "Ausstehende Bewertung",
  "after_sales_refund_order": "Bestellung erstatten",
  "Who we are": "Wer wir sind",
  "Women fashion": "Damenbekleidung",
  "Personal details": "Persönliche Details",
  "Password": "Passwort",
  "wishlist_empty_title": "Ihr Warenkorb ist leer",
  "Repeat_Password": "Passwort wiederholen",
  "cart_price": "Gesamt",
  "Sort_by": "Sortieren nach",
  "Customer Reviews": "Kundenbewertungen",
  "Continue to shipping": "Weiter zum Versand",
  "payment_make_order": "Bestellung aufgeben",
  "save_order_review": "Bewertung speichern",
  "Save_Password": "Passwort speichern",
  "cart_empty_title": "Ihr Warenkorb ist leer",
  "TopBar_help": "Hilfe und FAQs",
  "colseCookie": "Verstanden",
  "Password_Changed": "Ihr Passwort wurde erfolgreich geändert. Sie können nun zur Startseite zurückkehren und sich einloggen.",
  "Forgot Password Modal Email": "Ihre E-Mail-Adresse, mit der Sie sich registriert haben:",
  "MyAccount_Personal": "Persönliche Daten",
  "cartPreviewShipping": "Versand-Details",
  "ORDER_AFTER_SALE": "Kundendienst",
  "Page_not_found": "Seite nicht gefunden",
  "Find out more": "Mehr erfahren",
  "Log into your account": "Einloggen in Ihr Konto",
  "Details_and_status_orders": "Überprüfen Sie die Details und den Status Ihrer Bestellungen im Online-Shop. Sie können auch Bestellungen stornieren oder zurücksenden.",
  "Order_to_be_paid_message": "Zahlung ausstehend",
  "Guarantee": "Garantie",
  "Sections that interest you": "Interessante Abschnitte",
  "payment_post_tax": "MwSt.",
  "ORDER_PAID": "Bezahlt",
  "concactus_label5": "Anrede",
  "Item": "Produkt",
  "Go_back": "Zurück",
  "more": "Mehr",
  "MyAccount": "Mein Konto",
  "payment_agree_1": "Ich stimme zu",
  "total_items": "Anzahl Artikel",
  "shopping_go": "Versanddetails",
  "ID_Type": "Ausweisart",
  "after_sales_status": "Kundendienst-Status",
  "After_sales_apply": "Kundendienst beantragen",
  "Login": "Einloggen",
  "Quantity": "Menge",
  "payment_post_fee": "Versandkosten",
  "MyAccount_Log_out": "Abmelden",
  "Subtotal": "Zwischensumme",
  "forgotPasswordConfirmation": "Vielen Dank! Wenn Sie ein Konto mit der {0}-E-Mail-Adresse haben, finden Sie in Ihrem Posteingang eine Nachricht mit einem Link zum Zurücksetzen des Passworts.",
  "MyAccount_Order_History_Tabs1": "Meine Bestellungen",
  "concactus_img": "Foto hochladen",
  "Done": "Fertig",
  "Info after order": "Sie können sich mit Ihrer zuvor definierten E-Mail-Adresse und Ihrem Password bei Ihrem Konto anmelden. Über Ihr Konto können Sie Ihre persönlichen Daten bearbeiten, Ihre Transaktionshistorie überprüfen und Abonnements bearbeiten.",
  "MyAccoubnt_Set_newsletter": "Legen Sie Ihre Newsletter-Einstellungen fest. Wir senden Ihnen jede Woche neue Produkte und Trends aus Ihren ausgewählten Bereichen zu.",
  "Shipping_method": "Versandart",
  "after_sales_refund": "Rückerstattungsbetrag",
  "After_sales_save": "Kundendienst speichern",
  "go_order_history": "Bestellungshistorie anzeigen",
  "contactus_message_placeholder": "Geben Sie Ihre Kommentare oder Fragen ein",
  "Login_Forgot_Password": "Wenn Sie Ihr Passwort vergessen haben, können Sie es zurücksetzen.",
  "show_more": "Mehr anzeigen",
  "MyAccount_MyProfile_label_email": "Ihre E-Mail-Adresse",
  "MyAccount_MyProfile_label2_pass3": "Passwort wiederholen",
  "Products": "Produkte",
  "Review": "Bewertungen",
  "MyAccount_MyProfile_title3": "Ihre aktuelle E-Mail-Adresse lautet",
  "Category_found_Products": "Gefundene Produkte",
  "Match": "Match",
  "Read_all_reviews": "Alle Bewertungen lesen",
  "Commercial information": "Ich stimme zu, personalisierte kommerzielle Informationen von Brand name per E-Mail zu erhalten.",
  "Change password your account": "Wenn Sie das Passwort für Ihr Konto ändern möchten, geben Sie bitte die folgenden Informationen ein",
  "ID_Name": "Name im Ausweis",
  "All": "Alle",
  "Instruction2": "Benötigen Sie nur Pflegehinweise?",
  "MyAccount_ShippingDetails_Add": "Neue Adresse hinzufügen",
  "MyAccount_MyShippingDetails_Zip": "Postleitzahl",
  "go_pay_order": "Bezahlen",
  "Thank_You_Inbox": "Wenn die E-Mail nicht in Ihrem Posteingang angezeigt wird, versuchen Sie es bitte mit einer anderen E-Mail-Adresse, die Sie möglicherweise registriert haben.",
  "Subscribe": "Abonnieren",
  "confirm_subscription": "Ich bestätige die Abonnierung",
  "Login_input_Remember": "Angemeldet bleiben",
  "Add to compare": "Vergleichen",
  "Brand": "Marke",
  "Start_shopping": "Einkaufen beginnen",
  "Select shipping method": "Versandart auswählen",
  "address CN": "Die Adresse befindet sich in China. Die Währung muss RMB sein.",
  "MyAccount_MyShippingDetails_State": "Bundesland",
  "Page_not_found_message2": "Bitte zurückkehren oder erneut versuchen.",
  "Go_to_checkout": "Kasse",
  "See all results": "Alle Ergebnisse anzeigen",
  "search_results_inputnull": "Sie haben noch keine Produkte gesucht.",
  "subscribeToNewsletterModalContent": "Sie erhalten spezielle Angebote und Informationen von VSF per E-Mail, nachdem Sie den Newsletter abonniert haben. Wir werden Ihre E-Mail-Adresse niemals an Dritte weitergeben oder verkaufen. Weitere Informationen finden Sie in unserer {0}.",
  "Download all": "Alle herunterladen",
  "Login_input_last": "Nachname",
  "Amount": "Betrag",
  "ORDER_WAIT_PAYMENT": "Ausstehende Zahlung",
  "Order_After_sales": "Bestellung nach dem Verkauf",
  "concattus_button": "einreichen",
  "Shipping_valid_required": "Dies ist ein Pflichtfeld",
  "Price": "Preis",
  "ID_Type_Error": "Bitte wählen Sie Ihren ID-Typ aus",
  "Order_Status": "Bestellstatus",
  "Payment methods": "Zahlungsmethoden",
  "MyAccount_MyProfile_Tab2": "Passwort ändern",
  "Show on page": "Auf der Seite anzeigen",
  "Edit": "Bearbeiten",
  "Change": "Ändern",
  "MyAccount_ShippingDetails_Update": "Adresse aktualisieren",
  "View": "Ansehen",
  "Privacy": "Datenschutz",
  "Enter_promo_code": "Promotion-Code eingeben",
  "Discount": "Rabatt",
  "Delete": "Löschen",
  "Wishlist": "Wunschliste",
  "MyAccount_Order_History_Tabs3": "Rückgabe",
  "Go_To_Order_review": "Zur Bewertung gehen",
  "Update personal data": "Aktualisieren Sie Ihre persönlichen Daten",
  "payment_agree_2": "Bedingungen",
  "or fill the details below": "Oder füllen Sie die folgenden Details aus",
  "Contact details updated": "Halten Sie Ihre Adresse und Kontaktdaten auf dem neuesten Stand.",
  "Login_Create": "Konto erstellen",
  "Payment": "Bezahlung",
  "Billing": "Abrechnung",
  "payment_insurance_tax": "Versicherungssteuer",
  "Size guide": "Größenführer",
  "Login_forgotten_password": "Passwort vergessen?",
  "Login_no_account": "Noch kein Konto?",
  "Privacy_Policy": "Datenschutzrichtlinie",
  "BootomCookieTitle": "Cookie-Zulassung",
  "Use your personal data": "Bei Brandname legen wir großen Wert auf Datenschutz und bemühen uns, die persönlichen Daten unserer Nutzer zu schützen. Weitere Informationen darüber, wie wir mit Ihren persönlichen Daten umgehen und dafür sorgen, dass sie geschützt bleiben, finden Sie un",
  "Review my order": "Meine Bestellung überprüfen",
  "BootomCookieLink": "Mehr erfahren",
  "hide": "verstecken",
  "MyAccount_ShippingDetails_message_title": "Verwalten Sie alle Lieferadressen, die Sie wünschen (Arbeitsplatz, Wohnsitz usw.), so dass Sie nicht mehr bei jeder Bestellung manuell eine Lieferadresse eingeben müssen.",
  "Purchase terms": "Kaufbedingungen",
  "Billing_address": "Rechnungsadresse",
  "Manage shipping addresses": "Verwalten Sie alle Lieferadressen, die Sie wünschen (Arbeitsplatz, Wohnsitz usw.), um nicht bei jeder Bestellung manuell eine Lieferadresse eingeben zu müssen.",
  "login_logbtn": "Einloggen",
  "choose_currency": "Währung auswählen",
  "ORDER_REFUNDED": "erstattet",
  "After_sales_form": "Rückgabeformular ausfüllen",
  "add_To_Wishlist": "Zur Wunschliste hinzufügen",
  "search_results_inputnull2": "Fangen Sie jetzt an, wir helfen Ihnen.",
  "Total": "Gesamtbetrag",
  "Subscribe_to_newsletter": "Newsletter abonnieren",
  "Shipping_valid_Phone": "Bitte geben Sie eine gültige Telefonnummer an.",
  "concactus_label3": "Titel",
  "Manage billing addresses": "Verwalten Sie alle Rechnungsadressen, die Sie wünschen (Arbeitsplatz, Wohnsitz usw.), um nicht bei jeder Bestellung manuell eine Rechnungsadresse eingeben zu müssen.",
  "Search_results_title": "Suchergebnisse",
  "payment_order_payment": "Bestellung bezahlen",
  "after_sales_Id": "Rückgabe-ID",
  "cart_title": "Mein Warenkorb",
  "Order_Detail": "Bestelldetails",
  "concactus_label2": "Shop-Link",
  "Shipping_valid_length_min": "Dieses Feld sollte mindestens {min} Zeichen enthalten.",
  "Product suggestions": "Produktvorschläge",
  "Return_home": "Zurück zur Startseite",
  "Quality in the details": "Qualität in den Details",
  "Continue_to_payment": "Weiter zur Bezahlung",
  "Feedback": "Ihr Feedback ist uns wichtig. Bitte teilen Sie uns mit, was wir verbessern können.",
  "Go back to shop": "Zurück zum Geschäft",
  "Back_to_home": "Zurück zur Startseite",
  "Review_Content": "Bewertungsinhalt",
  "add_To_Cart": "In den Warenkorb legen",
  "Read_reviews": "Bewertungen lesen",
  "Instruction1": "Wartungsart",
  "Email_address": "E-Mail-Adresse",
  "Category_Item_List": "Wechseln Sie zur Listenansicht",
  "Same as shipping address": "Gleich wie Versandadresse",
  "Category_Item_Grid": "Wechseln Sie zur Rasteransicht",
  "ID_Number_Error": "Bitte geben Sie Ihre Ausweisnummer ein",
  "concactus_label4": "Kontakt-E-Mail",
  "Additional_info": "Zusätzliche Informationen",
  "add_shipping": "Neue Versandadresse hinzufügen",
  "Product_description": "Karissa V-Neck Tee ist ein semisitzendes Design, das für alle Körperformen geeignet ist. Es schmiegt sich an die Kurven an und deckt häufige \"Problemzonen\" ab, so dass Sie selbstbewusster ins Fitnessstudio gehen können. Es gibt auch atemberaubende Damenco",
  "Login_create_account": "Ich möchte ein Konto erstellen",
  "after_sales_Reason": "Grund für Rückgabe",
  "MyAccount_MyProfile_label_Last": "Nachname",
  "MyAccount_MyProfile_label2_pass2": "Neues Passwort",
  "Save": "Sparen",
  "CartSliderTextBtn": "Zur späteren Kaufaufbewahrung speichern",
  "Color": "Farbe",
  "Shipping_Tax": "Versandsteuer",
  "Subscribe_to_success": "Abonniert",
  "Enjoy your free account": "Genießen Sie Ihre kostenlosen Kontoprivilegien!",
  "cart_empty_desc": "Sie haben noch keine Produkte in Ihre Einkaufstasche gelegt. Beginnen Sie mit dem Einkaufen, um sie zu füllen.",
  "MyAccount_ShippingDetails_message_title2": "Aktualisieren Sie Ihre Adresse und Kontaktinformationen.",
  "An_error_occured": "Ein Fehler ist aufgetreten",
  "Country": "Land",
  "MyAccount_MyShippingDetails_First": "Vorname",
  "payment_insurance_fee": "Versicherungsgebühr",
  "Home": "home page",
  "Contact_us": "Kontaktiere uns",
  "Cookies Policy": "Cookie-Richtlinie",
  "Clear all": "Alles löschen",
  "Basket": "Warenkorb",
  "MyAccount_MyProfile_reqeatPassErrMsg": "Das neue Passwort stimmt nicht überein",
  "Your current email address is": "Ihre aktuelle E-Mail-Adresse lautet",
  "You currently have no orders": "Sie haben derzeit keine Bestellungen",
  "Login_input_password": "Passwort",
  "Promo_code": "Promotion-Code",
  "order_count": "Bestellungsanzahl",
  "email_geshi_error": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "your_email": "Ihre E-Mail-Adresse",
  "email": "E-Mail",
  "you_have_subscribed": "Sie haben bereits abonniert",
  "cancel_Subscribe": "Abonnement kündigen",
  "save_and_pay": "Speichern und bezahlen",
  "hasInsurance": "Haben Sie eine Versicherung gekauft",
  "pleasePayType": "Bitte wählen Sie eine Zahlungsmethode",
  "zhuanfa_toBePay": "Versende es an Freunde, um für dich zu bezahlen",
  "linkCopied": "Link kopiert, schnell einfügen und mit Freunden teilen",
  "Links": "Verknüpfungen",
  "article_category": "Artikel Kategorie",
  "wechat_code_login_message": "Bitte verwenden Sie WeChat, um den QR-Code zu scannen und sich anzumelden",
  "wechat_code_login": "WeChat-Anmeldung per QR-Code",
  "Api_Update_success": "Aktualisierung erfolgreich",
  "Please_Use_WeChat_login": "Bitte verwenden Sie WeChat, um sich anzumelden",
  "mobile_geshi_error": "Bitte geben Sie eine gültige Mobiltelefonnummer ein",
  "Login_input_email_required": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "article_null": "Keine Artikel verfügbar",
  "Login_with_microsoft": "Anmeldung bei Microsoft",
  "article_null_des": "Sie können Artikel in anderen Kategorien nachschlagen",
  "register_email": "E-Mail-Registrierung",
  "Login_tab_email": "Anmeldung per E-Mail",
  "code.time": "Erneute Versuche in {time} Sekunden",
  "Login_with_wechat": "Anmeldung bei WeChat",
  "cat_items_null_des": "Sie können Produkte in anderen Kategorien durchsuchen",
  "Login_with_facebook": "Anmeldung bei Facebook",
  "Login_input_code": "Bestätigungscode",
  "Login_input_mobile_required": "Bitte geben Sie Ihre Handynummer ein",
  "Login_input_mobile": "Ihre Handynummer",
  "cat_items_null": "Keine Produkte in dieser Kategorie verfügbar",
  "Login_with_twitter": "Anmeldung bei Twitter",
  "mobile_code": "Bestätigungscode",
  "register_mobile": "Handy-Registrierung",
  "Login_tab_mobile": "Anmeldung per Handy",
  "Login_with_google": "Anmeldung bei Google",
  "OrderSku": "Produktspezifikation",
  "Order_logisticsNo": "Sendungsnummer",
  "order_shopping_firstname": "Name",
  "Order_logisticsName": "Logistikunternehmen",
  "ItemPrice": "Warenbetrag",
  "inPayOrderAll": "Zahlungsstatusliste",
  "payPrice": "Zahlungsbetrag",
  "shipping_add_success": "Lieferadresse erfolgreich erstellt",
  "match_goods": "Bestseller",
  "pay_code_refresh": "Aktualisieren Sie den Zahlungskode",
  "pay_code_shixiao": "Die Zahlung QR-Code ist abgelaufen",
  "concactus_title": "Kontaktiere uns",
  "Search_items": "Suche",
  "WebAutoLang": "Ihre empfohlene Sprache im aktuellen Browser ist: {lang}. Möchten Sie zur Sprache wechseln?",
  "Services_Name": "Service Name",
  "Services_Price": "Servicegebühr",
  "SwichLang": "Sprache wechseln",
  "Services_Description": "Service-Beschreibung",
  "goodinfo_null": "Keine Artikel verfügbar",
  "goodinfo_null_des": "Sie können andere Kategorien von Waren durchsuchen",
  "notYetUseCode": "Nicht verwendet Gutscheincode",
  "guest_Login": "Gast-Anmeldung",
  "billing_and_shipping": "Rechnung und Lieferadresse gleich",
  "select_coupon": "Wählen Sie Gutschein",
  "select_gift": "Wählen Sie ein Geschenk",
  "currentUseCode": "Bereits genutzter Gutscheincode",
  "shipping_refresh": "Aktualisieren Sie die Liste",
  "Shipping_details": "Versanddetails",
  "MyAccount_Newsletter": "Newsletter",
  "MyAccount_Profile": "Profil",
  "MyAccount_Wishlist": "Wunschzettel",
  "See_all": "Alle",
  "MyAccount_History": "Bestellverlauf",
  "bind_microsoft": "Verknüpfung mit Microsoft",
  "bind_twitter": "Verknüpfung mit Twitter",
  "bind_facebook": "Verknüpfung mit Facebook",
  "bind_wechat_code": "WeChat-QR-Code",
  "bind_wechat": "Verknüpfung mit WeChat",
  "bind_google": "Verknüpfung mit Google",
  "Wishlist_Empty": "Keine Wunschliste",
  "discount_post_fee": "Versandkostenrabatt",
  "ORDER_PART_PAID": "Teilzahlung",
  "claimCouponeSuccess": "{name} erfolgreich erhalten",
  "discount_kou": "{discount} Rabatt",
  "claimCoupone": "Beanspruchen",
  "cartPreviewSafety_messageinfo": "Sichere und schnelle Lieferung an Ihre Adresse",
  "Order_No": "Bestellnummer",
  "cartPreviewSafety": "Sicherer Versand",
  "Shipping": "Versand",
  "MyAccount_MyShippingDetails_Street": "Straße",
  "MyAccount_MyShippingDetails_HouseNumber": "Hausnummer",
  "Shipping_title": "Lieferadresse",
  "Offline_payment": "Offline-Zahlung",
  "shopName": "Geschäftsnamen",
  "Social": "Social-Medien",
  "SERVICE": "Dienstleistung",
  "onlineContact": "Online-Kontakt",
  "confirm": "Bestätigung",
  "closeOrder": "Bestellung stornieren",
  "closeOrderContext": "Sind Sie sicher, dass Sie die Bestellung stornieren möchten?",
  "Message_Read": "Gelesen",
  "close.order.success": "Bestellung erfolgreich storniert",
  "shippingAddress": "Adresse",
  "Message": "Nachricht",
  "Message_Empty_Title": "Ihre Nachrichten sind leer",
  "MyAccount_Message": "Nachricht",
  "Message_Empty": "Keine Nachrichten",
  "payment_order_note": "Bestellhinweis",
  "go_to_see_prepid": "Klicken Sie hier, um unbezahlte Bestellungen anzuzeigen",
  "operate": "Betrieben",
  "removeCartItemContext": "Sind Sie sicher, dass Sie {title} entfernen möchten?",
  "shippingItemQty": "Versandmenge",
  "removeCartItem": "Artikel entfernen",
  "shippingInfo": "Versandinformationen",
  "Distributor_success": "Bereits erfolgreich als Händler",
  "Distributor_apply": "Als Händler bewerben",
  "Distributor_Details": "Händler",
  "DistributorSataus": "Status",
  "Distributor_Details_Empty": "Keine Händler vorhanden",
  "distributor.status.4": "Ungültig",
  "distributor.status.1": "Nicht überprüft",
  "Distributor_copy_url": "Kopieren des Verkaufslinks",
  "Order_Time": "Bestellzeit",
  "Order_User": "Besteller",
  "Distributor_copy_success": "Erfolgreich kopiert",
  "distributor.status.3": "Abgerechnet",
  "MyAccount_Distributor": "Händler",
  "MyAccoubnt_Set_Distributor": "Als Händler bewerben",
  "distributor.status.2": "In Abrechnung",
  "DistributorAmount": "Provision",
  "Distributor_shenheshibai": "Vertriebshändlerüberprüfung fehlgeschlagen",
  "Distributor_shenhezhong": "Vertriebshändlerprüfung läuft",
  "Distributor_Order_Empty": "Keine Vertriebsaufträge vorübergehend",
  "NE": "Niger",
  "DJ": "Dschibuti",
  "KP": "Nordkorea",
  "US": "Vereinigte Staaten",
  "LC": "St. Lucia",
  "NL": "Niederlande",
  "CD": "Kongo (Demokratische Republik)",
  "IS": "Island",
  "MA": "Marokko",
  "GH": "Ghana",
  "KR": "Südkorea",
  "MK": "Mazedonien",
  "HT": "Haiti",
  "PF": "Französisch-Polynesien",
  "GA": "Gabun",
  "TD": "Tschad",
  "LB": "Libanon",
  "CG": "Kongo",
  "KG": "Kirgisistan",
  "TA": "Tristan da Cunha",
  "KW": "Kuwait",
  "TL": "Osttimor",
  "IN": "Indien",
  "NO": "Norwegen",
  "NG": "Nigeria",
  "AQ": "Antarktis",
  "LY": "Libyen",
  "NI": "Nicaragua",
  "TT": "Trinidad und Tobago",
  "HM": "Heard und McDonaldinseln",
  "PY": "Paraguay",
  "BA": "Bosnien und Herzegowina",
  "JP": "Japan",
  "MD": "Moldawien",
  "MT": "Malta",
  "RE": "Réunion",
  "UG": "Uganda",
  "SB": "Salomonen",
  "SL": "Sierra Leone",
  "CV": "Kap Verde",
  "SD": "Sudan",
  "FO": "Färöer-Inseln",
  "ZA": "Südafrika",
  "TR": "Türkei",
  "FK": "Falklandinseln",
  "PA": "Panama",
  "GF": "Französisch-Guayana",
  "TJ": "Tadschikistan",
  "NC": "Neukaledonien",
  "PM": "Saint-Pierre und Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Vietnam",
  "GN": "Guinea",
  "MW": "Malawi",
  "BY": "Weißrussland",
  "IM": "Isle of Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Cook-Inseln",
  "MH": "Marshallinseln",
  "CR": "Costa Rica",
  "HK": "Hongkong (SAR) China",
  "AD": "Andorra",
  "BN": "Brunei",
  "SN": "Senegal",
  "AE": "Vereinigte Arabische Emirate",
  "GI": "Gibraltar",
  "CA": "Kanada",
  "AX": "Alandinseln",
  "UY": "Uruguay",
  "WF": "Wallis und Futuna",
  "GM": "Gambia",
  "SO": "Somalia",
  "RU": "Russland",
  "PL": "Polen",
  "FM": "Mikronesien",
  "ET": "Äthiopien",
  "EE": "Estland",
  "SK": "Slowakei",
  "AS": "Amerikanisch-Samoa",
  "ZM": "Sambia",
  "AL": "Albanien",
  "AT": "Österreich",
  "VA": "Vatikanstadt",
  "TW": "Taiwan",
  "BD": "Bangladesch",
  "AR": "Argentinien",
  "EH": "Westsahara",
  "MO": "Macao S.A.R. China",
  "MV": "Malediven",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chile",
  "IL": "Israel",
  "GD": "Grenada",
  "WS": "Samoa",
  "SE": "Schweden",
  "GP": "Guadeloupe",
  "YE": "Jemen",
  "GT": "Guatemala",
  "BG": "Bulgarien",
  "SJ": "Svalbard und Jan Mayen",
  "CO": "Kolumbien",
  "LS": "Lesotho",
  "LV": "Lettland",
  "UM": "Amerikanische Überseeinseln",
  "MX": "Mexiko",
  "DO": "Dominikanische Republik",
  "PE": "Peru",
  "HN": "Honduras",
  "TC": "Turks- und Caicosinseln",
  "VI": "Amerikanische Jungferninseln",
  "FJ": "Fidschi",
  "MP": "Nördliche Marianen",
  "AC": "Ascension",
  "NA": "Namibia",
  "SZ": "Eswatini",
  "RW": "Ruanda",
  "BH": "Bahrain",
  "KN": "St. Kitts und Nevis",
  "TN": "Tunesien",
  "AF": "Afghanistan",
  "VG": "Britische Jungferninseln",
  "KE": "Kenia",
  "PK": "Pakistan",
  "GL": "Grönland",
  "SY": "Syrien",
  "CU": "Kuba",
  "RS": "Serbien",
  "BF": "Burkina Faso",
  "BM": "Bermuda",
  "BZ": "Belize",
  "SV": "El Salvador",
  "CN": "China",
  "MF": "Saint Martin",
  "NF": "Norfolkinsel",
  "MZ": "Mosambik",
  "LU": "Luxemburg",
  "TO": "Tonga",
  "GR": "Griechenland",
  "SI": "Slowenien",
  "PW": "Palau",
  "TZ": "Tansania",
  "IR": "Iran",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "Französische Süd- und Antarktisgebiete",
  "PS": "Palästinensische Gebiete",
  "SC": "Seychellen",
  "BT": "Bhutan",
  "JM": "Jamaika",
  "BR": "Brasilien",
  "CH": "Schweiz",
  "SH": "St. Helena",
  "HU": "Ungarn",
  "TM": "Turkmenistan",
  "LT": "Litauen",
  "MC": "Monaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Georgien",
  "SA": "Saudi-Arabien",
  "GB": "Vereinigtes Königreich",
  "VE": "Venezuela",
  "MU": "Mauritius",
  "HR": "Kroatien",
  "SR": "Suriname",
  "CM": "Kamerun",
  "IQ": "Irak",
  "BO": "Bolivien",
  "MN": "Mongolei",
  "DZ": "Algerien",
  "TK": "Tokelau",
  "MG": "Madagaskar",
  "YT": "Mayotte",
  "CC": "Kokosinseln",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Katar",
  "AN": "Niederländische Antillen",
  "PN": "Pitcairninseln",
  "ES": "Spanien",
  "VC": "St. Vincent und die Grenadinen",
  "AU": "Australien",
  "CX": "Weihnachtsinsel",
  "KM": "Komoren",
  "MR": "Mauretanien",
  "FR": "Frankreich",
  "SG": "Singapur",
  "BV": "Bouvetinsel",
  "PH": "Philippinen",
  "CY": "Zypern",
  "TV": "Tuvalu",
  "CF": "Zentralafrikanische Republik",
  "EC": "Ecuador",
  "GW": "Guinea-Bissau",
  "IE": "Irland",
  "LK": "Sri Lanka",
  "ER": "Eritrea",
  "GQ": "Äquatorialguinea",
  "NP": "Nepal",
  "BE": "Belgien",
  "GY": "Guyana",
  "DK": "Dänemark",
  "MQ": "Martinique",
  "UZ": "Usbekistan",
  "CI": "Elfenbeinküste",
  "ID": "Indonesien",
  "BJ": "Benin",
  "ST": "São Tomé und Príncipe",
  "KH": "Kambodscha",
  "KZ": "Kasachstan",
  "MS": "Montserrat",
  "TH": "Thailand",
  "FI": "Finnland",
  "ML": "Mali",
  "AM": "Armenien",
  "IT": "Italien",
  "NR": "Nauru",
  "PG": "Papua-Neuguinea",
  "ZW": "Simbabwe",
  "JO": "Jordanien",
  "OM": "Oman",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "Neuseeland",
  "VU": "Vanuatu",
  "DE": "Deutschland",
  "CZ": "Tschechien",
  "DM": "Dominica",
  "KY": "Kaimaninseln",
  "BW": "Botswana",
  "RO": "Rumänien",
  "PR": "Puerto Rico",
  "AZ": "Aserbaidschan",
  "IO": "Britisches Territorium im Indischen Ozean",
  "UA": "Ukraine",
  "TG": "Togo",
  "MY": "Malaysia",
  "AG": "Antigua und Barbuda",
  "EG": "Ägypten",
  "GS": "Südgeorgien und Südliche Sandwichinseln",
  "MM": "Myanmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "All_Country": "Alle",
  "post_state_country": "Versandkosten: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "Lieferung nach",
  "ShippingFee": "Versandgebühr",
  "reviewOutOf": "{rating} Sterne, insgesamt 5 Sterne",
  "product.pifa.label": "Kaufen Sie {startnum} - {endnum} Stück",
  "product.pifa.type.1": "Rabatt",
  "Write_a_review": "Eine Bewertung schreiben",
  "BasedOnTotalReviews": "Basierend auf {total} Bewertungen",
  "product.wholesale": "Großhandelspreis",
  "reviewMostRecent": "Neueste Bewertungen",
  "product.pifa.type.2": "Einzelpreis",
  "product.num.danwei": "Stück",
  "good.shoppingDateLabel": "Versanddatum",
  "good.shippingPeriod": "Versand innerhalb von Tagen",
  "emailError": "E-Mail-Format falsch",
  "addressNote": "Anmerkung zur Adresse",
  "Concactus": "Kontakt",
  "addressMessage": "Bitte stellen Sie sicher, dass Ihre Adresse korrekt ist. Nach dem Auschecken können wir die Adresse nicht ändern.",
  "showOrderSummary": "Auftragszusammenfassung",
  "payment_method": "Zahlungsmethode",
  "emailNotNullError": "E-Mail darf nicht leer sein",
  "orderCreateLoading": "Bestellung wird erstellt...",
  "emailNote": "Kontakt",
  "emailMessage": "Bitte stellen Sie sicher, dass Ihre E-Mail-Adresse korrekt ist. Wir senden Ihnen eine Bestellbestätigungs-E-Mail.",
  "payment_method_message": "Alle Transaktionen sind sicher und verschlüsselt.",
  "go_buy_goods": "Weiter einkaufen",
  "tap_cancel_order": "Klicken Sie hier, um die Bestellung abzubrechen",
  "order_review": "Bestellbewertung",
  "Add_new_address": "Neue Adresse hinzufügen",
  "promo_code_type_3": "Gutscheine erhalten",
  "IdCardNotNull": "Bitte geben Sie Ihre richtigen Informationen an.",
  "UploadVideo": "Video hochladen",
  "video": "Video",
  "UploadImage": "Bild hochladen",
  "uploadImageing": "Hochladen...",
  "BillingInfoNotNull": "Unvollständige Rechnungsinformationen",
  "promo_code_type_2": "Gutschein",
  "UploadError": "Upload fehlgeschlagen",
  "promo_code_type_4": "Versandkosten reduzieren",
  "image": "Bild",
  "paymentMethodNotNull": "Bitte wählen Sie Ihre Zahlungsweise",
  "promo_code_type_1": "Rabatt-Gutschein",
  "shippingInfoNotNull": "Unvollständige Versandinformationen",
  "reviewDetail": "Bewertungsdetails",
  "DeliveryCountry": "Liefersland",
  "prompt_error": "Hinweis Fehler",
  "save_review_success": "Bewertung erfolgreich",
  "ORDER_COMPLETED": "abgeschlossen",
  "crate_after_sales": "Nach dem Verkauf erstellen",
  "Thank_You_Order": "Vielen Dank für Ihre Bestellung!",
  "Thank_You_Order_sub": "In Kürze werden wir mit der Bearbeitung Ihrer Bestellung beginnen. Sie erhalten eine E-Mail mit Informationen zur Bestellabwicklung.",
  "BootomCookieContext": "Diese Website verwendet Cookies, um die ordnungsgemäße Funktionsweise der Website zu unterstützen und uns dabei zu helfen, zu verstehen, wie Sie damit interagieren. Wir verwenden diese Cookies, um Ihnen eine bessere personalisierte Benutzererfahrung zu bi",
  "order_reivice_message": "Haben Sie die Ware erhalten?",
  "order_reivice_btn": "Bestätigen Sie den Eingang",
  "order_reivice_label": "Auftrags Eingang",
  "order_reivice_success": "Bestätigen Sie den Eingangs erfolgreich",
  "collpase_show": "mehr anzeigen",
  "collpase_hide": "verstecken",
  "CouponCode": "Gutscheincode",
  "wechatPayScannerCode": "Bitte mit WeChat-Scan zahlen",
  "processing": "Nachverkaufsbearbeitung",
  "finished": "Nachverkauf abgeschlossen",
  "login.showPrice": "Preise nach dem Login anzeigen",
  "After_Sales_Unknown": "Nachverkaufsstatus unbekannt",
  "order_payment_list_null": "Keine ausstehenden Bestellungen",
  "Cancel": "Abbrechen",
  "thankyou_concat": "Bitte kontaktieren Sie uns, wenn Sie Fragen haben"
}